@file:OptIn(InternalResourceApi::class)

package dentalcrm.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/dentalcrm.composeapp.generated.resources/"

@delegate:ResourceContentHash(-2_100_213_678)
internal val Res.string.month_eleven: StringResource by lazy {
      StringResource("string:month_eleven", "month_eleven", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6132, 36),
      ))
    }

@delegate:ResourceContentHash(1_735_869_043)
internal val Res.string.month_eleven_short: StringResource by lazy {
      StringResource("string:month_eleven_short", "month_eleven_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6093, 38),
      ))
    }

@delegate:ResourceContentHash(-1_717_589_506)
internal val Res.string.month_five: StringResource by lazy {
      StringResource("string:month_five", "month_five", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6202, 26),
      ))
    }

@delegate:ResourceContentHash(-1_717_589_506)
internal val Res.string.month_five_short: StringResource by lazy {
      StringResource("string:month_five_short", "month_five_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6169, 32),
      ))
    }

@delegate:ResourceContentHash(-1_659_274_973)
internal val Res.string.month_four: StringResource by lazy {
      StringResource("string:month_four", "month_four", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6262, 34),
      ))
    }

@delegate:ResourceContentHash(1_031_472_964)
internal val Res.string.month_four_short: StringResource by lazy {
      StringResource("string:month_four_short", "month_four_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6229, 32),
      ))
    }

@delegate:ResourceContentHash(-1_678_610_965)
internal val Res.string.month_nine: StringResource by lazy {
      StringResource("string:month_nine", "month_nine", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6334, 42),
      ))
    }

@delegate:ResourceContentHash(-534_453_977)
internal val Res.string.month_nine_short: StringResource by lazy {
      StringResource("string:month_nine_short", "month_nine_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6297, 36),
      ))
    }

@delegate:ResourceContentHash(-303_628_232)
internal val Res.string.month_one: StringResource by lazy {
      StringResource("string:month_one", "month_one", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6409, 33),
      ))
    }

@delegate:ResourceContentHash(1_317_805_729)
internal val Res.string.month_one_short: StringResource by lazy {
      StringResource("string:month_one_short", "month_one_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6377, 31),
      ))
    }

@delegate:ResourceContentHash(-1_866_371_729)
internal val Res.string.month_seven: StringResource by lazy {
      StringResource("string:month_seven", "month_seven", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6481, 31),
      ))
    }

@delegate:ResourceContentHash(-1_866_371_729)
internal val Res.string.month_seven_short: StringResource by lazy {
      StringResource("string:month_seven_short", "month_seven_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6443, 37),
      ))
    }

@delegate:ResourceContentHash(-1_864_524_687)
internal val Res.string.month_six: StringResource by lazy {
      StringResource("string:month_six", "month_six", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6549, 29),
      ))
    }

@delegate:ResourceContentHash(-1_864_524_687)
internal val Res.string.month_six_short: StringResource by lazy {
      StringResource("string:month_six_short", "month_six_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6513, 35),
      ))
    }

@delegate:ResourceContentHash(1_265_697_972)
internal val Res.string.month_ten: StringResource by lazy {
      StringResource("string:month_ten", "month_ten", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6611, 37),
      ))
    }

@delegate:ResourceContentHash(659_320_911)
internal val Res.string.month_ten_short: StringResource by lazy {
      StringResource("string:month_ten_short", "month_ten_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6579, 31),
      ))
    }

@delegate:ResourceContentHash(355_606_659)
internal val Res.string.month_three: StringResource by lazy {
      StringResource("string:month_three", "month_three", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6687, 31),
      ))
    }

@delegate:ResourceContentHash(355_606_659)
internal val Res.string.month_three_short: StringResource by lazy {
      StringResource("string:month_three_short", "month_three_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6649, 37),
      ))
    }

@delegate:ResourceContentHash(-419_833_603)
internal val Res.string.month_twelve: StringResource by lazy {
      StringResource("string:month_twelve", "month_twelve", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6754, 40),
      ))
    }

@delegate:ResourceContentHash(1_489_520_986)
internal val Res.string.month_twelve_short: StringResource by lazy {
      StringResource("string:month_twelve_short", "month_twelve_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6719, 34),
      ))
    }

@delegate:ResourceContentHash(493_002_034)
internal val Res.string.month_two: StringResource by lazy {
      StringResource("string:month_two", "month_two", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6827, 37),
      ))
    }

@delegate:ResourceContentHash(-1_917_942_562)
internal val Res.string.month_two_short: StringResource by lazy {
      StringResource("string:month_two_short", "month_two_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6795, 31),
      ))
    }

@delegate:ResourceContentHash(2_119_400_898)
internal val Res.string.name: StringResource by lazy {
      StringResource("string:name", "name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6927, 20),
      ))
    }

@delegate:ResourceContentHash(824_772_272)
internal val Res.string.name_required: StringResource by lazy {
      StringResource("string:name_required", "name_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6865, 61),
      ))
    }

@delegate:ResourceContentHash(-1_033_126_753)
internal val Res.string.no_inspection: StringResource by lazy {
      StringResource("string:no_inspection", "no_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6948, 77),
      ))
    }

@delegate:ResourceContentHash(471_870_062)
internal val Res.string.no_quick_replies: StringResource by lazy {
      StringResource("string:no_quick_replies", "no_quick_replies", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7026, 72),
      ))
    }

@delegate:ResourceContentHash(1_207_556_224)
internal val Res.string.no_selected_services: StringResource by lazy {
      StringResource("string:no_selected_services", "no_selected_services", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7099, 80),
      ))
    }

@delegate:ResourceContentHash(877_262_279)
internal val Res.string.no_services_selected: StringResource by lazy {
      StringResource("string:no_services_selected", "no_services_selected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7180, 76),
      ))
    }

@delegate:ResourceContentHash(1_834_570_382)
internal val Res.string.not_visited: StringResource by lazy {
      StringResource("string:not_visited", "not_visited", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7307, 43),
      ))
    }

@delegate:ResourceContentHash(1_834_570_382)
internal val Res.string.not_visited_short: StringResource by lazy {
      StringResource("string:not_visited_short", "not_visited_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7257, 49),
      ))
    }

@delegate:ResourceContentHash(-1_763_973_897)
internal val Res.string.open_github: StringResource by lazy {
      StringResource("string:open_github", "open_github", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7351, 35),
      ))
    }

@delegate:ResourceContentHash(-1_120_792_536)
internal val Res.string.option: StringResource by lazy {
      StringResource("string:option", "option", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7419, 30),
      ))
    }

@delegate:ResourceContentHash(-1_121_436_778)
internal val Res.string.options: StringResource by lazy {
      StringResource("string:options", "options", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7387, 31),
      ))
    }

@delegate:ResourceContentHash(-400_609_160)
internal val Res.string.or_separator: StringResource by lazy {
      StringResource("string:or_separator", "or_separator", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7450, 28),
      ))
    }

@delegate:ResourceContentHash(-1_046_428_316)
internal val Res.string.parenthesis: StringResource by lazy {
      StringResource("string:parenthesis", "parenthesis", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7479, 43),
      ))
    }

@delegate:ResourceContentHash(-45_761_455)
internal val Res.string.password: StringResource by lazy {
      StringResource("string:password", "password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7628, 32),
      ))
    }

@delegate:ResourceContentHash(2_080_172_299)
internal val Res.string.password_hint: StringResource by lazy {
      StringResource("string:password_hint", "password_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7523, 65),
      ))
    }

@delegate:ResourceContentHash(-45_761_455)
internal val Res.string.password_label: StringResource by lazy {
      StringResource("string:password_label", "password_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7589, 38),
      ))
    }

@delegate:ResourceContentHash(2_004_866_434)
internal val Res.string.patient_appointments_empty: StringResource by lazy {
      StringResource("string:patient_appointments_empty", "patient_appointments_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7661, 102),
      ))
    }

@delegate:ResourceContentHash(-972_336_182)
internal val Res.string.patient_date: StringResource by lazy {
      StringResource("string:patient_date", "patient_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7764, 76),
      ))
    }

@delegate:ResourceContentHash(-1_715_132_336)
internal val Res.string.patient_detail: StringResource by lazy {
      StringResource("string:patient_detail", "patient_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7841, 62),
      ))
    }

@delegate:ResourceContentHash(-389_737_682)
internal val Res.string.patient_formatter: StringResource by lazy {
      StringResource("string:patient_formatter", "patient_formatter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7904, 49),
      ))
    }

@delegate:ResourceContentHash(1_068_187_313)
internal val Res.string.patient_status: StringResource by lazy {
      StringResource("string:patient_status", "patient_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7954, 62),
      ))
    }

@delegate:ResourceContentHash(-276_986_435)
internal val Res.string.patients: StringResource by lazy {
      StringResource("string:patients", "patients", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8017, 40),
      ))
    }

@delegate:ResourceContentHash(-835_819_144)
internal val Res.string.pending: StringResource by lazy {
      StringResource("string:pending", "pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8092, 43),
      ))
    }

@delegate:ResourceContentHash(1_618_786_885)
internal val Res.string.pending_short: StringResource by lazy {
      StringResource("string:pending_short", "pending_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8058, 33),
      ))
    }

@delegate:ResourceContentHash(-91_119_440)
internal val Res.string.permissions_label: StringResource by lazy {
      StringResource("string:permissions_label", "permissions_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8136, 45),
      ))
    }

@delegate:ResourceContentHash(1_962_512_355)
internal val Res.string.phone: StringResource by lazy {
      StringResource("string:phone", "phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8253, 49),
      ))
    }

@delegate:ResourceContentHash(1_649_113_561)
internal val Res.string.phone_required: StringResource by lazy {
      StringResource("string:phone_required", "phone_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8182, 70),
      ))
    }

@delegate:ResourceContentHash(-355_158_454)
internal val Res.string.pick_doctor: StringResource by lazy {
      StringResource("string:pick_doctor", "pick_doctor", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8303, 55),
      ))
    }

@delegate:ResourceContentHash(-1_715_132_336)
internal val Res.string.pick_patient: StringResource by lazy {
      StringResource("string:pick_patient", "pick_patient", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8359, 60),
      ))
    }

@delegate:ResourceContentHash(1_610_527_195)
internal val Res.string.positions: StringResource by lazy {
      StringResource("string:positions", "positions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8500, 41),
      ))
    }

@delegate:ResourceContentHash(884_156_335)
internal val Res.string.positions_services_info: StringResource by lazy {
      StringResource("string:positions_services_info", "positions_services_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8420, 79),
      ))
    }

@delegate:ResourceContentHash(-1_348_850_552)
internal val Res.string.price_label: StringResource by lazy {
      StringResource("string:price_label", "price_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8542, 31),
      ))
    }

@delegate:ResourceContentHash(1_239_290_464)
internal val Res.string.protocol: StringResource by lazy {
      StringResource("string:protocol", "protocol", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9298, 60),
      ))
    }

@delegate:ResourceContentHash(-1_368_767_302)
internal val Res.string.protocol_add_title: StringResource by lazy {
      StringResource("string:protocol_add_title", "protocol_add_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8574, 90),
      ))
    }

@delegate:ResourceContentHash(-1_107_891_351)
internal val Res.string.protocol_delete_option: StringResource by lazy {
      StringResource("string:protocol_delete_option", "protocol_delete_option", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8665, 66),
      ))
    }

@delegate:ResourceContentHash(1_293_804_809)
internal val Res.string.protocol_delete_question: StringResource by lazy {
      StringResource("string:protocol_delete_question", "protocol_delete_question", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8732, 68),
      ))
    }

@delegate:ResourceContentHash(-396_247_381)
internal val Res.string.protocol_edit_title: StringResource by lazy {
      StringResource("string:protocol_edit_title", "protocol_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8801, 91),
      ))
    }

@delegate:ResourceContentHash(-1_904_167_444)
internal val Res.string.protocol_option_label: StringResource by lazy {
      StringResource("string:protocol_option_label", "protocol_option_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8893, 45),
      ))
    }

@delegate:ResourceContentHash(-1_336_012_377)
internal val Res.string.protocol_options_label: StringResource by lazy {
      StringResource("string:protocol_options_label", "protocol_options_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8939, 70),
      ))
    }

@delegate:ResourceContentHash(1_218_976_019)
internal val Res.string.protocol_question_number: StringResource by lazy {
      StringResource("string:protocol_question_number", "protocol_question_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9010, 56),
      ))
    }

@delegate:ResourceContentHash(-483_211_748)
internal val Res.string.protocol_question_text: StringResource by lazy {
      StringResource("string:protocol_question_text", "protocol_question_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9067, 66),
      ))
    }

@delegate:ResourceContentHash(2_077_600_868)
internal val Res.string.protocol_title_edit_title: StringResource by lazy {
      StringResource("string:protocol_title_edit_title", "protocol_title_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9134, 97),
      ))
    }

@delegate:ResourceContentHash(469_022_073)
internal val Res.string.protocols: StringResource by lazy {
      StringResource("string:protocols", "protocols", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9232, 65),
      ))
    }

@delegate:ResourceContentHash(-719_490_999)
internal val Res.string.quantity_label: StringResource by lazy {
      StringResource("string:quantity_label", "quantity_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9359, 50),
      ))
    }

@delegate:ResourceContentHash(1_280_888_248)
internal val Res.string.question: StringResource by lazy {
      StringResource("string:question", "question", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9410, 32),
      ))
    }

@delegate:ResourceContentHash(-584_164_198)
internal val Res.string.quick_replies: StringResource by lazy {
      StringResource("string:quick_replies", "quick_replies", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9620, 57),
      ))
    }

@delegate:ResourceContentHash(-718_204_832)
internal val Res.string.quick_replies_add_title: StringResource by lazy {
      StringResource("string:quick_replies_add_title", "quick_replies_add_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9443, 87),
      ))
    }

@delegate:ResourceContentHash(-1_234_451_958)
internal val Res.string.quick_replies_edit_title: StringResource by lazy {
      StringResource("string:quick_replies_edit_title", "quick_replies_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9531, 88),
      ))
    }

@delegate:ResourceContentHash(-738_733_094)
internal val Res.string.quick_reply_message: StringResource by lazy {
      StringResource("string:quick_reply_message", "quick_reply_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9678, 51),
      ))
    }

@delegate:ResourceContentHash(-1_227_755_671)
internal val Res.string.reload: StringResource by lazy {
      StringResource("string:reload", "reload", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9730, 38),
      ))
    }

@delegate:ResourceContentHash(-912_420_438)
internal val Res.string.reply_by_template: StringResource by lazy {
      StringResource("string:reply_by_template", "reply_by_template", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9769, 73),
      ))
    }

@delegate:ResourceContentHash(-1_614_154_894)
internal val Res.string.reply_message_hint: StringResource by lazy {
      StringResource("string:reply_message_hint", "reply_message_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9843, 70),
      ))
    }

@delegate:ResourceContentHash(2_640_728)
internal val Res.string.run: StringResource by lazy {
      StringResource("string:run", "run", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9914, 15),
      ))
    }

@delegate:ResourceContentHash(61_039_519)
internal val Res.string.save: StringResource by lazy {
      StringResource("string:save", "save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9930, 36),
      ))
    }

@delegate:ResourceContentHash(-1_570_644_529)
internal val Res.string.search: StringResource by lazy {
      StringResource("string:search", "search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10004, 30),
      ))
    }

@delegate:ResourceContentHash(-1_570_644_529)
internal val Res.string.search_label: StringResource by lazy {
      StringResource("string:search_label", "search_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9967, 36),
      ))
    }

@delegate:ResourceContentHash(-877_847_295)
internal val Res.string.select: StringResource by lazy {
      StringResource("string:select", "select", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10372, 34),
      ))
    }

@delegate:ResourceContentHash(733_277_112)
internal val Res.string.select_all: StringResource by lazy {
      StringResource("string:select_all", "select_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10035, 46),
      ))
    }

@delegate:ResourceContentHash(156_123_126)
internal val Res.string.select_diagnosis: StringResource by lazy {
      StringResource("string:select_diagnosis", "select_diagnosis", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10082, 68),
      ))
    }

@delegate:ResourceContentHash(-638_945_290)
internal val Res.string.select_pin_color: StringResource by lazy {
      StringResource("string:select_pin_color", "select_pin_color", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10151, 60),
      ))
    }

@delegate:ResourceContentHash(-1_523_819_595)
internal val Res.string.select_template: StringResource by lazy {
      StringResource("string:select_template", "select_template", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10212, 83),
      ))
    }

@delegate:ResourceContentHash(-614_583_965)
internal val Res.string.selected_services_label: StringResource by lazy {
      StringResource("string:selected_services_label", "selected_services_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10296, 75),
      ))
    }

@delegate:ResourceContentHash(895_385_353)
internal val Res.string.send_telegram: StringResource by lazy {
      StringResource("string:send_telegram", "send_telegram", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10407, 61),
      ))
    }

@delegate:ResourceContentHash(-1_169_089_182)
internal val Res.string.service_add: StringResource by lazy {
      StringResource("string:service_add", "service_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10651, 59),
      ))
    }

@delegate:ResourceContentHash(-1_506_183_740)
internal val Res.string.service_add_success: StringResource by lazy {
      StringResource("string:service_add_success", "service_add_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10469, 99),
      ))
    }

@delegate:ResourceContentHash(2_131_784_239)
internal val Res.string.service_add_title: StringResource by lazy {
      StringResource("string:service_add_title", "service_add_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10569, 81),
      ))
    }

@delegate:ResourceContentHash(-2_142_580_172)
internal val Res.string.service_categories: StringResource by lazy {
      StringResource("string:service_categories", "service_categories", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10711, 66),
      ))
    }

@delegate:ResourceContentHash(1_588_520_905)
internal val Res.string.service_category: StringResource by lazy {
      StringResource("string:service_category", "service_category", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10855, 68),
      ))
    }

@delegate:ResourceContentHash(-1_559_789_789)
internal val Res.string.service_category_add: StringResource by lazy {
      StringResource("string:service_category_add", "service_category_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10778, 76),
      ))
    }

@delegate:ResourceContentHash(763_440_363)
internal val Res.string.service_description: StringResource by lazy {
      StringResource("string:service_description", "service_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10924, 51),
      ))
    }

@delegate:ResourceContentHash(1_140_881_895)
internal val Res.string.service_duration: StringResource by lazy {
      StringResource("string:service_duration", "service_duration", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10976, 84),
      ))
    }

@delegate:ResourceContentHash(-977_209_332)
internal val Res.string.service_max_price: StringResource by lazy {
      StringResource("string:service_max_price", "service_max_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11061, 69),
      ))
    }

@delegate:ResourceContentHash(514_455_369)
internal val Res.string.service_naming: StringResource by lazy {
      StringResource("string:service_naming", "service_naming", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11131, 54),
      ))
    }

@delegate:ResourceContentHash(-1_348_850_552)
internal val Res.string.service_price: StringResource by lazy {
      StringResource("string:service_price", "service_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11186, 33),
      ))
    }

@delegate:ResourceContentHash(-389_038_368)
internal val Res.string.service_update: StringResource by lazy {
      StringResource("string:service_update", "service_update", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11293, 62),
      ))
    }

@delegate:ResourceContentHash(477_776_805)
internal val Res.string.service_update_title: StringResource by lazy {
      StringResource("string:service_update_title", "service_update_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11220, 72),
      ))
    }

@delegate:ResourceContentHash(286_649_519)
internal val Res.string.services: StringResource by lazy {
      StringResource("string:services", "services", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11500, 32),
      ))
    }

@delegate:ResourceContentHash(286_649_519)
internal val Res.string.services_label: StringResource by lazy {
      StringResource("string:services_label", "services_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11356, 38),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("month_eleven", Res.string.month_eleven)
  map.put("month_eleven_short", Res.string.month_eleven_short)
  map.put("month_five", Res.string.month_five)
  map.put("month_five_short", Res.string.month_five_short)
  map.put("month_four", Res.string.month_four)
  map.put("month_four_short", Res.string.month_four_short)
  map.put("month_nine", Res.string.month_nine)
  map.put("month_nine_short", Res.string.month_nine_short)
  map.put("month_one", Res.string.month_one)
  map.put("month_one_short", Res.string.month_one_short)
  map.put("month_seven", Res.string.month_seven)
  map.put("month_seven_short", Res.string.month_seven_short)
  map.put("month_six", Res.string.month_six)
  map.put("month_six_short", Res.string.month_six_short)
  map.put("month_ten", Res.string.month_ten)
  map.put("month_ten_short", Res.string.month_ten_short)
  map.put("month_three", Res.string.month_three)
  map.put("month_three_short", Res.string.month_three_short)
  map.put("month_twelve", Res.string.month_twelve)
  map.put("month_twelve_short", Res.string.month_twelve_short)
  map.put("month_two", Res.string.month_two)
  map.put("month_two_short", Res.string.month_two_short)
  map.put("name", Res.string.name)
  map.put("name_required", Res.string.name_required)
  map.put("no_inspection", Res.string.no_inspection)
  map.put("no_quick_replies", Res.string.no_quick_replies)
  map.put("no_selected_services", Res.string.no_selected_services)
  map.put("no_services_selected", Res.string.no_services_selected)
  map.put("not_visited", Res.string.not_visited)
  map.put("not_visited_short", Res.string.not_visited_short)
  map.put("open_github", Res.string.open_github)
  map.put("option", Res.string.option)
  map.put("options", Res.string.options)
  map.put("or_separator", Res.string.or_separator)
  map.put("parenthesis", Res.string.parenthesis)
  map.put("password", Res.string.password)
  map.put("password_hint", Res.string.password_hint)
  map.put("password_label", Res.string.password_label)
  map.put("patient_appointments_empty", Res.string.patient_appointments_empty)
  map.put("patient_date", Res.string.patient_date)
  map.put("patient_detail", Res.string.patient_detail)
  map.put("patient_formatter", Res.string.patient_formatter)
  map.put("patient_status", Res.string.patient_status)
  map.put("patients", Res.string.patients)
  map.put("pending", Res.string.pending)
  map.put("pending_short", Res.string.pending_short)
  map.put("permissions_label", Res.string.permissions_label)
  map.put("phone", Res.string.phone)
  map.put("phone_required", Res.string.phone_required)
  map.put("pick_doctor", Res.string.pick_doctor)
  map.put("pick_patient", Res.string.pick_patient)
  map.put("positions", Res.string.positions)
  map.put("positions_services_info", Res.string.positions_services_info)
  map.put("price_label", Res.string.price_label)
  map.put("protocol", Res.string.protocol)
  map.put("protocol_add_title", Res.string.protocol_add_title)
  map.put("protocol_delete_option", Res.string.protocol_delete_option)
  map.put("protocol_delete_question", Res.string.protocol_delete_question)
  map.put("protocol_edit_title", Res.string.protocol_edit_title)
  map.put("protocol_option_label", Res.string.protocol_option_label)
  map.put("protocol_options_label", Res.string.protocol_options_label)
  map.put("protocol_question_number", Res.string.protocol_question_number)
  map.put("protocol_question_text", Res.string.protocol_question_text)
  map.put("protocol_title_edit_title", Res.string.protocol_title_edit_title)
  map.put("protocols", Res.string.protocols)
  map.put("quantity_label", Res.string.quantity_label)
  map.put("question", Res.string.question)
  map.put("quick_replies", Res.string.quick_replies)
  map.put("quick_replies_add_title", Res.string.quick_replies_add_title)
  map.put("quick_replies_edit_title", Res.string.quick_replies_edit_title)
  map.put("quick_reply_message", Res.string.quick_reply_message)
  map.put("reload", Res.string.reload)
  map.put("reply_by_template", Res.string.reply_by_template)
  map.put("reply_message_hint", Res.string.reply_message_hint)
  map.put("run", Res.string.run)
  map.put("save", Res.string.save)
  map.put("search", Res.string.search)
  map.put("search_label", Res.string.search_label)
  map.put("select", Res.string.select)
  map.put("select_all", Res.string.select_all)
  map.put("select_diagnosis", Res.string.select_diagnosis)
  map.put("select_pin_color", Res.string.select_pin_color)
  map.put("select_template", Res.string.select_template)
  map.put("selected_services_label", Res.string.selected_services_label)
  map.put("send_telegram", Res.string.send_telegram)
  map.put("service_add", Res.string.service_add)
  map.put("service_add_success", Res.string.service_add_success)
  map.put("service_add_title", Res.string.service_add_title)
  map.put("service_categories", Res.string.service_categories)
  map.put("service_category", Res.string.service_category)
  map.put("service_category_add", Res.string.service_category_add)
  map.put("service_description", Res.string.service_description)
  map.put("service_duration", Res.string.service_duration)
  map.put("service_max_price", Res.string.service_max_price)
  map.put("service_naming", Res.string.service_naming)
  map.put("service_price", Res.string.service_price)
  map.put("service_update", Res.string.service_update)
  map.put("service_update_title", Res.string.service_update_title)
  map.put("services", Res.string.services)
  map.put("services_label", Res.string.services_label)
}
